import noop from '@gaia/util/noop/action'
import submitFavorite from 'app/_shared/action/favorite/submit'
import successFavorite from 'app/_shared/action/favorite/success'

export default {
  index: noop,
  submitFavorite,
  successFavorite,
}
